module.exports = __webpack_public_path__ + "img/Ballot.582f8c3d.svg";